// src/utils/precios.js

/**
 * Calcula el precio de venta de un artículo usando la ganancia personalizada
 * si existe; si no, usa la ganancia global del usuario.
 *
 * Soporta la fórmula legacy del frontend: PRE_VTA * (1 + ganancia / 100).
 *
 * @param {Object} articulo - Debe contener al menos `PRE_VTA` y opcionalmente `ganancia_personalizada`.
 * @param {number} gananciaGlobal - Porcentaje de ganancia global del usuario.
 * @returns {number} Precio de venta calculado.
 */
export const calcularPrecioVenta = (articulo, gananciaGlobal) => {
  if (!articulo) return 0;

  const ganancia =
    articulo.ganancia_personalizada !== null && articulo.ganancia_personalizada !== undefined
      ? parseFloat(articulo.ganancia_personalizada)
      : parseFloat(gananciaGlobal || 0);

  const precioBase = parseFloat(articulo.PRE_VTA || 0);

  return precioBase * (1 + ganancia / 100);
};

/**
 * Devuelve el % de ganancia efectivo que se aplicó (personalizado o global).
 * Útil para mostrar en la UI.
 */
export const obtenerGananciaEfectiva = (articulo, gananciaGlobal) => {
  if (!articulo) return 0;
  return articulo.ganancia_personalizada !== null && articulo.ganancia_personalizada !== undefined
    ? parseFloat(articulo.ganancia_personalizada)
    : parseFloat(gananciaGlobal || 0);
};

/**
 * Extrae el número del campo FORMATO (ej: "6u" → 6, "12un" → 12).
 * Si no hay formato o es inválido, devuelve 1.
 */
export const extraerFormato = (formato) => {
  if (!formato) return 1;
  const matches = String(formato).match(/[+-]?([0-9]*[.])?[0-9]+/);
  if (!matches) return 1;
  const num = parseFloat(matches[0]);
  return num > 0 ? num : 1;
};

/**
 * Calcula el precio unitario: PRE_VTA / formato.
 * Si formato es 1 o no existe, devuelve el precio base sin dividir.
 */
export const calcularPrecioUnitario = (precioBase, formato) => {
  const factor = extraerFormato(formato);
  if (factor === 1) return precioBase;
  return precioBase / factor;
};
